import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-grid p-fluid" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-print",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "print" }
const _hoisted_6 = { class: "table align-middle table-row-dashed table-bordered table-sm" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "18",
      class: "text-center",
      style: {"background-color":"#e9ecef"}
    }, " Sipariş Raporu ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-70px" }, "Sipariş"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-70px" }, "Tarih"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Müşteri"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-70px" }, "Departman"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Üretici"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Model Kodu"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Artikel"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Order"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Sezon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Yükleme Tarihi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Sevk Tarihi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-60px text-end" }, "Adet"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Fiyat"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Toplam Tutar"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Sevk Edilen"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Sevk Tutarı"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Silen Kişi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Silinme Nedeni")
  ])
], -1)
const _hoisted_8 = { class: "text-gray-600" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { colspan: "11" }, null, -1)
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1)
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = { class: "text-end" }

import { ref, withDefaults } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Field } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { useToast } from "primevue/usetoast";
import Checkbox from "primevue/checkbox";
export interface PropsModel {
  isActive: boolean;
  data: any;
  currencyType: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'print-order-report',
  props: {
    isActive: { type: Boolean, default: false },
    data: { default: null },
    currencyType: { default: null }
  },
  emits: ["changeReceipt"],
  setup(__props: any, { emit }) {

const props = __props as { isActive: boolean, data: any, currencyType: any }

const updateButtonDisabled = ref(false);



const isActive = ref(props.isActive);
const toast = useToast();
const yetki = ref();
const store = useStore();

const toggleModal = () => {
  isActive.value = !isActive.value;
};

const onChange = (args) => {
  emit("changeReceipt", args);
};

const print = () => {
  var panel = document.getElementsByClassName("print")[0];
  var printWindow = window.open("", "", "");
  printWindow?.document.write(
    "<html><head><link rel='stylesheet' href='style/print.css'><title>Sipariş Raporu</title>"
  );
  printWindow?.document.write("</head><body >");
  printWindow?.document.write(panel.innerHTML);
  printWindow?.document.write("</body></html>");
  printWindow?.document.close();
  setTimeout(function () {
    printWindow?.print();
    printWindow?.close();
  }, 500);

  return false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    onClose: onChange,
    modalActive: props.isActive,
    title: "Silinen Sipariş Raporu",
    width: "100vw"
  }, {
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            id: "performance-report_submit",
            ref: "submitButtonSettings",
            class: "btn btn-primary",
            style: {"margin-bottom":"5px","width":"100px"},
            onClick: print
          }, _hoisted_4, 512),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "odd",
                    key: item.orderId
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.orderId), 1),
                    _createElementVNode("td", null, _toDisplayString(item.orderDate), 1),
                    _createElementVNode("td", null, _toDisplayString(item.customerName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.department), 1),
                    _createElementVNode("td", null, _toDisplayString(item.supplierName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.modelCode), 1),
                    _createElementVNode("td", null, _toDisplayString(item.articleNumber), 1),
                    _createElementVNode("td", null, _toDisplayString(item.order), 1),
                    _createElementVNode("td", null, _toDisplayString(item.seasonName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.shippingDate), 1),
                    _createElementVNode("td", null, _toDisplayString(item.deliveryDate), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(item.orderQuantity), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(parseFloat(item.orderLinePrice)
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                      .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(__props.currencyType), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(parseFloat(item.totalPrice)
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                      .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(__props.currencyType), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.shipped), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(parseFloat(item.deliveryTotalPrice)
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                      .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(__props.currencyType), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item.employee), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(item.reasonDeleted), 1)
                  ]))
                }), 128)),
                _createElementVNode("tr", null, [
                  _hoisted_16,
                  _createElementVNode("td", _hoisted_17, _toDisplayString(props.data
                      .map((f) => f.orderQuantity)
                      .reduce(function (a, b) {
                        return a + b;
                      }, 0)), 1),
                  _hoisted_18,
                  _createElementVNode("td", _hoisted_19, _toDisplayString(props.data
                      .map((f) => f.totalPrice)
                      .reduce(function (a, b) {
                        return a + b;
                      }, 0)
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                      .replace(/\.(\d+)$/, ",$1")
                      .toString()) + " " + _toDisplayString(props.currencyType), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(props.data
                      .map((f) => f.shipped)
                      .reduce(function (a, b) {
                        return a + b;
                      }, 0)), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(props.data
                      .map((f) => f.deliveryTotalPrice)
                      .reduce(function (a, b) {
                        return a + b;
                      }, 0)
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                      .replace(/\.(\d+)$/, ",$1")
                      .toString()) + " " + _toDisplayString(props.currencyType), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})